import React from 'react';
import { QueryClient } from '@tanstack/react-query';

const useInitializeGlobalQueryClient = () => {
    return React.useState(
        () =>
            new QueryClient({
                defaultOptions: {
                    queries: {
                        // With SSR, we usually want to set some default staleTime
                        // above 0 to avoid refetching immediately on the client
                        staleTime: 60 * 1000,
                    },
                },
            }),
    );
};

export default useInitializeGlobalQueryClient;
